import React, {Component} from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import {Container, Header, Segment, Icon, Image, Grid} from 'semantic-ui-react';
const coverImage = require('../assets/img/support.jpeg');
const cupImage = require('../assets/img/cup.png');
const clientsImage = require('../assets/img/clientes.png');
const coverStyle = {
  backgroundColor: '#1F1214',
  backgroundImage: `url(${coverImage})`,
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed'
};
const mainSegmentStyle = {
  height: '70vh',
  background: 'rgba(0,0,0,0)',
  backgroundColor: 'hsl(0, 0%, 100%)',
  mixBlendMode: 'screen',
  marginBottom: '50vh'
};
const headerStyle = {
  textTransform: 'uppercase',
  textShadow: 'rgb(152, 152, 152) 9px 4px 0px',  
  color: 'black',

  position: 'absolute',
  bottom: 20,
  width: '100%',
  left: 0,
  right: 0
};
const subheaderStyle = {
  color: 'black',
  textShadow: 'none'
};
const secondaryHeaderStyle = {
  color: 'orange',
  display: 'inline-block',

};
const textStyle = {
  fontSize: '16pt'
}
class SupportView extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (

        <Container fluid style={coverStyle}>
          <Segment size="massive" textAlign="center" basic className="coversegment">
            <Header as="h1" style={headerStyle}>
            <Header.Subheader style={subheaderStyle}>
                Un servicio que te deja tranquilo
              </Header.Subheader>
              Soporte
              
            </Header>
            
          </Segment>
          <Grid
            padded
            relaxed
            stackable
            style={{
            backgroundColor: 'white'
          }}>
            <Grid.Row columns={1} style={{marginTop: "30px"}}>
              <Grid.Column>
              <Header  color="grey" as="h2" textAlign="center" style={{color: 'white', fontSize: '4em'}}>
                Soporte tecnico y mantenimiento
                <Header.Subheader style={{fontSize: "0.5em"}}>
                  Asistencia brindada por profesionales, listos para solucionar cualquier inconveniente.
                </Header.Subheader>
              </Header>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={3} style={{padding: '30px'}}>
              <Grid.Column>
               <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="wrench" color="yellow" />
                  Mantenimiento preventivo
                  <Header.Subheader>
                    Para evitar fallas
                  </Header.Subheader>
                </Header>
              </Grid.Column>
              <Grid.Column>
                <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="hospital" color="blue" />
                  Mantenimiento correctivo
                </Header>
              </Grid.Column>
              <Grid.Column>
                <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="alarm" color="red" />
                  Servicio de urgencias
                </Header>
              </Grid.Column>
                            <Grid.Column>
               <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="cloud" color="purple" />
                  Backup diario
                </Header>
              </Grid.Column>
              <Grid.Column>
                <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="angle double up" color="green" />
                  Mantenimiento evolutivo
                </Header>
              </Grid.Column>
              <Grid.Column>
                <Header icon color="grey" as="h2" textAlign="center" style={{color: 'white'}}>
                  <Icon name="phone" color="grey" />
                  Asistencia técnica
                </Header>
              </Grid.Column>
            </Grid.Row>
          </Grid>
                    <div style={{margin: '5px', textAlign: "center", color: "white"}}><strong>Teniente Cundom 1574 - Corrientes - Argentina</strong></div>
        </Container>
      
    );
  }
}

export default SupportView;



// WEBPACK FOOTER //
// ./client/containers/SupportView.js